export const setPageNumberForCohortPage = (state, payload) => {
    return {
        ...state,
        pageNumberCohort: payload
    }
}